import { Typography } from '@mui/material'
import { fontSizes, fontLineHeights, fontWeights, fontLetterSpacings } from './TypographyStyles' // Adjust the path as necessary

const TypographyPanel = () => {
  return (
    <div style={{ padding: '20px' }}>
      <Typography
        sx={{
          marginLeft: 2,
          fontSize: fontSizes.size24,
          lineHeight: fontLineHeights.ratio1to1,
          letterSpacing: fontLetterSpacings.medium,
          fontWeight: fontWeights[700], // Bold for main heading
        }}
        gutterBottom
      >
        Typography Showcase
      </Typography>

      {/* Font Sizes */}
      <section>
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio1to1,
            letterSpacing: fontLetterSpacings.medium,
            fontWeight: fontWeights[500],
          }}
          gutterBottom
        >
          Font Sizes
        </Typography>
        {Object.keys(fontSizes).map((sizeKey) => (
          <div key={sizeKey} style={{ marginBottom: '20px' }}>
            <Typography
              sx={{
                marginLeft: 2,
                fontSize: fontSizes[sizeKey],
                lineHeight: fontLineHeights.ratio1to1,
                letterSpacing: fontLetterSpacings.medium,
                fontWeight: fontWeights[400], // Normal weight
              }}
            >
              Font Size {sizeKey}: The quick brown fox jumps over the lazy dog.
            </Typography>
          </div>
        ))}
      </section>

      {/* Font Weights */}
      {/* <section>
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio1to1,
            letterSpacing: fontLetterSpacings.medium,
            fontWeight: fontWeights[500],
          }}
          gutterBottom
        >
          Font Weights
        </Typography>
        {Object.keys(fontWeights).map((weight) => (
          <div key={weight} style={{ marginBottom: '20px' }}>
            <Typography
              sx={{
                marginLeft: 2,
                fontSize: fontSizes.size16,
                lineHeight: fontLineHeights.ratio1to1,
                letterSpacing: fontLetterSpacings.medium,
                fontWeight: fontWeights[weight],
              }}
            >
              Font Weight {weight}: The quick brown fox jumps over the lazy dog.
            </Typography>
          </div>
        ))}
      </section> */}

      {/* Line Heights */}
      <section>
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio1to1,
            letterSpacing: fontLetterSpacings.medium,
            fontWeight: fontWeights[500],
          }}
          gutterBottom
        >
          Line Heights
        </Typography>
        {Object.keys(fontLineHeights).map((ratio) => (
          <div key={ratio} style={{ marginBottom: '20px' }}>
            <Typography
              sx={{
                marginLeft: 2,
                fontSize: fontSizes.size16,
                lineHeight: fontLineHeights[ratio],
                letterSpacing: fontLetterSpacings.medium,
                fontWeight: fontWeights[400], // Normal weight
              }}
            >
              Line Height {ratio}: The quick brown fox jumps over the lazy dog.
            </Typography>
          </div>
        ))}
      </section>

      {/* Letter Spacing */}
      <section>
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio1to1,
            letterSpacing: fontLetterSpacings.medium,
            fontWeight: fontWeights[500],
          }}
          gutterBottom
        >
          Letter Spacing
        </Typography>
        {Object.keys(fontLetterSpacings).map((spacing) => (
          <div key={spacing} style={{ marginBottom: '20px' }}>
            <Typography
              sx={{
                marginLeft: 2,
                fontSize: fontSizes.size16,
                lineHeight: fontLineHeights.ratio1to1,
                letterSpacing: fontLetterSpacings[spacing],
                fontWeight: fontWeights[400], // Normal weight
              }}
            >
              Letter Spacing {spacing}: The quick brown fox jumps over the lazy dog.
            </Typography>
          </div>
        ))}
      </section>

      {/* Subscript and Superscript */}
      <section>
        <Typography
          sx={{
            marginLeft: 2,
            fontSize: fontSizes.size20,
            lineHeight: fontLineHeights.ratio1to1,
            letterSpacing: fontLetterSpacings.medium,
            fontWeight: fontWeights[500],
          }}
          gutterBottom
        >
          Subscript and Superscript
        </Typography>
        <div style={{ marginBottom: '20px' }}>
          <Typography
            sx={{
              marginLeft: 2,
              fontSize: fontSizes.size16,
              lineHeight: fontLineHeights.ratio1to1,
              letterSpacing: fontLetterSpacings.medium,
              fontWeight: fontWeights[400], // Normal weight
            }}
          >
            Subscript and Superscript: Consider this: $0<sub>1</sub> first month
            <sup>1</sup>.
          </Typography>
        </div>
      </section>
    </div>
  )
}

export default TypographyPanel
